import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const gridItemProductCardSx:SxProps = {
    display:'flex',
    maxWidth:globalBreak({mobile:'50%', desktop:'100%'}),
}  

export const headerSX:SxProps = {
    paddingTop: 2,
    paddingBottom: 2,
}

export const subHeaderSX:SxProps = {
    paddingTop: 2,
    paddingBottom: 2,
    fontWeight: 'bold'
}